export function AgencyEmptyState() {
  return (
    <div className="border-2 border-dashed border-line bg-surface px-6 py-12 text-center">
      <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted">
        No agencies yet
      </p>
      <h2 className="mt-3 text-lg font-semibold text-ink">Start with your first agency</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted">
        Agencies will appear here once they are created on the platform.
      </p>
    </div>
  )
}
